<template>
  <div class="sa-list-component">
    <div class="sa-list-component-header">
      <b-form @submit.prevent="onSubmit">
        <b-row class="sa-form-btn-filter">
          <b-col cols="12">
            <date-filter-component ref="cmpDateFilterComponent"></date-filter-component>
          </b-col>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
            <!-- <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button> -->
          </b-col>
        </b-row>
      </b-form>
    </div>
    <div class="sa-list-component-body">
      <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col lg="3">
          <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col lg="9">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
            size="sm"></b-pagination>
        </b-col>
      </b-row>
      <div class="b-table-sticky-header">
        <b-table sticky-header ref="table" stacked="lg" striped hover :items="storicoItems" :fields="fieldsColumn"
          :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
          <template #cell(soggetto)="row">
            <span>{{ row.item.cognomeRagioneSoggetto }} {{ row.item.nomeSoggetto }}</span>
          </template>
          <template #cell(articolo)="row">
            <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
              row.item.descrizione }}</span>
            <span style="font-weight: 400; display: flex; width: 100%; justify-content: start; align-items: center">{{
              row.item.codiceArticolo }} </span>
          </template>
          <template #cell(documento)="row">
            <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
              row.item.tipoDocumentoDescrizione }}</span>
            <span style="font-weight: 400; display: flex; width: 100%; justify-content: start; align-items: center"> ({{
              row.item.numeroDocumento }}) </span>
            <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
              getData(row.item.documentoData) }} </span>
          </template>
          <template #cell(causaleDocumentoOperazioneMagazzino)="row">
            <span :style="getStyleOperazioneMagazzino(row.item.causaleDocumentoOperazioneMagazzino)">{{
              getDescrizioneOperazioneMagazzino(row.item.causaleDocumentoOperazioneMagazzino) }}</span>
          </template>
          <template #cell(actions)="row">
            <b-button size="sm" v-b-tooltip.hover title="Visualizza Documento" variant="outline-secondary"
              @click="onClickModalOpenPdf(row)">
              <font-awesome-icon icon="file-pdf" />
            </b-button>
            <b-button size="sm" v-b-tooltip.hover title="Visualizza Documento" variant="outline-secondary"
              @click="onClickVisualizzaDocumento(row)">
              <font-awesome-icon icon="eye" />
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
    <div class="sa-list-component-footer">
      <b-modal ref="mdlStampaReferto" size="xl" style="height: 100%">
        <b-embed type="iframe" :src="stampaReport" allowfullscreen></b-embed>
      </b-modal>
      <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col lg="3">
          <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col lg="9">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
            size="sm"></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import DateFilterComponent from "../../utility/components/DateFilterComponent.vue";
// import ModalError from "../../../template/components/modal/components/ModalError.vue";
import moment from "moment";
export default {
  name: "MagazzinoArticoliTabStoricoContabileComponent",
  mixins: [UtilityMixin],
  props: {
    visibleColumns: {
      type: Array,
      required: false,
      default: () => {
        return null;
      },
    },
  },
  computed: {
    fieldsColumn() {
      let me = this;
      let columns = [];
      if (!this.visibleColumns) {
        columns = this.fieldStorico;
      } else {
        columns = me.fieldStorico.filter((value) => this.visibleColumns.includes(value.key));
      }
      return columns;
    },
  },
  components: { DateFilterComponent },
  mounted() { },

  data() {
    return {
      currentPage: 1,
      perPage: 10,
      filtro: {},
      pathResource: "/contabilitadocumenti",
      pathResourceStampa: "/print/createreport",
      reportName: "documenti",
      stampaReport: null,
      rows: 0,
      fieldStorico: [
        {
          label: "Documento",
          key: "documento",
          sortable: true,
        },
        {
          label: "Codice Articolo",
          key: "articolo",
          sortable: true,
        },
        {
          label: "Soggetto",
          key: "soggetto",
          sortable: true,
        },
        {
          label: "Qnt.",
          key: "quantita",
          sortable: true,
        },
        {
          label: "Prezzo Un.",
          key: "prezzoUnitario",
          sortable: true,
          formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
        },
        {
          label: "Tip. Movimento",
          key: "causaleDocumentoOperazioneMagazzino",
          sortable: true,
        },
        {
          class: "sa-table-column-action-double",
          label: "",
          key: "actions",
        },
      ],
      jsonData: {},
      filter: {},
      storicoItems: [],
      pathResouce: "/contabilitadocumentorighe/storicogiacenza",
    };
  },
  methods: {
    init(filtro) {
      if (filtro) {
        this.filtro = filtro;
      }
      this.loadStoricoGiacenzaArticolo();
      // this.loadStoricoGiacenzaArticoliMagazzino();
    },
    // loadStoricoGiacenzaArticoliMagazzino() {
    //   let me = this;
    //   UtilityMixin.methods.loadDataResources("/contabilitadocumentorighe/giacenze", this.filtro, me.loadStoricoGiacenzaArticoliMagazzinoSuccess, me.loadStoricoGiacenzaArticoliMagazzinoError);
    // },
    // loadStoricoGiacenzaArticoliMagazzinoSuccess(response) {
    //   //let me = this;
    //   console.log(response);
    // },
    // loadStoricoGiacenzaArticoliMagazzinoError(error) {
    //   console.log(error);
    // },
    loadStoricoGiacenzaArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResouce, this.filtro, me.loadStoricoGiacenzaArticoloSuccess, me.loadStoricoGiacenzaArticoloError);
    },
    loadStoricoGiacenzaArticoloSuccess(response) {
      let me = this;
      me.rows = response.data.data.list.length;
      me.storicoItems = response.data.data.list;
    },
    loadStoricoGiacenzaArticoloError(error) {
      console.log(error);
    },
    getStyleOperazioneMagazzino(value) {
      return { color: value > 0 ? "green" : "red" };
    },
    getData(value) {
      return moment(new Date(value)).format("DD/MM/YYYY");
    },
    getDescrizioneOperazioneMagazzino(value) {
      return value > 0 ? "CARICO" : "SCARICO";
    },
    onSubmit() {
      let dateFilter = this.$refs.cmpDateFilterComponent.getFilter();
      this.filtro.dataDal = dateFilter.dataDal;
      this.filtro.dataAl = dateFilter.dataAl;
      this.loadStoricoGiacenzaArticolo();
    },
    onClickModalOpenPdf(row) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + row.item.idDocumento;
      axios.get(link).then((response) => {
        let printData = response.data.data;
        let linkReport = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
        axios.post(linkReport, { reportName: me.reportName, data: printData }).then((response) => {
          me.$refs.mdlStampaReferto.show();
          me.stampaReport = "data:application/pdf;base64," + response.data.base64;
        });
      });
    },
    onClickVisualizzaDocumento(row) {
      let pathDocumentoFe = "/contabilita/documenti/view/";
      this.$router.push(pathDocumentoFe + row.item.idDocumento);
    },
    onReset() { },
  },
};
</script>
